import { Container, Typography, Box, Theme, Link } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  Icon48BrandBabysitters,
  Icon48BrandHousekeeping,
  Icon48BrandTutoring,
  Icon48BrandNannies,
  Icon48BrandPetCare,
  Icon48BrandSeniorCare,
} from '@care/react-icons';
import { SxClassProps } from '@/types/common';

const classes: SxClassProps = {
  jobListContainer: (theme: Theme) => ({
    cursor: 'pointer',
    margin: theme.spacing(2, 1.5, 1.5, 1.5),

    [theme.breakpoints.up('md')]: {
      margin: 2,
      '&:first-of-type': {
        marginLeft: 0,
      },
    },
  }),
  sideJobIcon: {
    width: '88px',
    height: '88px',
    border: '1px solid',
    borderColor: 'care.grey.300',
    borderRadius: 3,
    display: 'inline-block',
    padding: 2.5,
    '& svg': {
      width: '48px',
      height: '48px',
    },
  },
  careOptionsName: {
    color: 'care.navy.900',
    textDecoration: 'none',
    display: 'block',
    cursor: 'pointer',
    width: '90px',
    marginTop: '10px',
    lineHeight: '22px',
  },
};

/* This is a static list */
const optionsList = [
  { id: 1, name: 'Babysitters', icon: <Icon48BrandBabysitters />, verticalURL: '/babysitters' },
  { id: 2, name: 'Nannies', icon: <Icon48BrandNannies />, verticalURL: '/nannies' },
  { id: 3, name: 'Tutoring', icon: <Icon48BrandTutoring />, verticalURL: '/tutors' },
  { id: 4, name: 'House keeping', icon: <Icon48BrandHousekeeping />, verticalURL: '/housekeepers' },
  { id: 5, name: 'Pet care', icon: <Icon48BrandPetCare />, verticalURL: '/pet-care' },
  { id: 6, name: 'Senior care', icon: <Icon48BrandSeniorCare />, verticalURL: '/senior-care' },
] as const;

const CareOptions = ({ hasCareCheck }: { hasCareCheck: boolean }) => {
  const isMobileOrSmaller = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  return (
    <Container maxWidth="md">
      <Box pt={5}>
        <Typography variant={isMobileOrSmaller ? 'h4' : 'h2'} color="secondary" mt={1}>
          Or take a look at some other care options
        </Typography>
        <Box
          display="flex"
          mb={{ xs: 3, md: 0 }}
          flexWrap="wrap"
          justifyContent={{ xs: 'center', md: 'flex-start' }}
          textAlign="center">
          {optionsList.map((option) => (
            <Box key={option.id} sx={classes.jobListContainer}>
              <Link sx={{ '.MuiTypography-root': { display: 'block' } }} href={option.verticalURL}>
                <Box sx={classes.sideJobIcon}>{option.icon}</Box>
                <Typography sx={classes.careOptionsName} variant="h4">
                  {option.name}
                </Typography>
              </Link>
            </Box>
          ))}
        </Box>
      </Box>
      {!hasCareCheck && (
        <Typography variant="body2" my={2} mx={0} width="75%">
          Caregiver profile is illustrative only. This caregiver may not have a current, active
          account or background check. Care.com members can access active, background checked
          caregivers.
        </Typography>
      )}
    </Container>
  );
};

export default CareOptions;
